import React from "react";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";

const AnonymousRoute = ({
  user,
  component: Component,
  to_if_authenticated,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      !user.isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to={to_if_authenticated} />
      )
    }
  />
);

AnonymousRoute.propTypes = {
  user: PropTypes.object.isRequired,
  component: PropTypes.any.isRequired,
  to_if_authenticated: PropTypes.string.isRequired,
};

export default AnonymousRoute;
